import common from "../../helper/common";
import { rebuildAppRouter } from "../../router";
import {
  addProfileMenu,
  updateUserState,
  getDefaultRoute,
  refreshPage,
  NAVIGATION_DELAY,
} from "./authHelpers";

/**
 * Handle club change from SignalR or other sources
 */
export const handleClubChange = async (
  newClubId,
  user,
  setUser,
  currentClubIdRef,
  setRoutesReady
) => {
  if (!newClubId || newClubId === currentClubIdRef.current) {
    return;
  }

  try {
    const response = await common.ApiService.getInstance().request(
      `ChangeDefaultClub?clubId=${newClubId}`,
      {},
      "POST"
    );

    if (!response?.data) {
      console.error("[AuthContext] Invalid response from ChangeDefaultClub");
      return;
    }

    const updatedRoleName = response.data.roleName || user?.roleName;
    const updatedMenus = addProfileMenu(response.data.menus || [], user?.id);

    const updatedUser = {
      ...user,
      roleName: updatedRoleName,
      defaultClubId: newClubId,
      menus: updatedMenus,
    };

    updateUserState(updatedUser, setUser, currentClubIdRef);

    if (updatedMenus.length > 0) {
      await rebuildAppRouter();
      setRoutesReady(true);
    }

    common.SweetAlert.alert(
      response.message || "Club changed successfully.",
      "success"
    );

    const defaultRoute = getDefaultRoute(updatedMenus);
    setTimeout(() => {
      window.location.href = defaultRoute;
    }, NAVIGATION_DELAY);
  } catch (error) {
    console.error("[AuthContext] Error syncing club change:", error);
    common.SweetAlert.alert(
      "Failed to change club. Please try again.",
      "error"
    );
  }
};

/**
 * Handle permission change from SignalR
 * Updates menus from finalResult and refreshes page
 */
export const handlePermissionChange = async (
  finalResult,
  message,
  user,
  setUser,
  currentClubIdRef,
  setRoutesReady
) => {
  if (!user?.id) {
    return;
  }

  try {
    // finalResult contains updated permissions/menus from backend
    // It can be: array of menus, or object with menus property
    const updatedMenus = Array.isArray(finalResult)
      ? finalResult
      : finalResult?.menus || [];

    if (updatedMenus.length === 0) {
      console.warn("[AuthContext] No menus in permission update");
      return;
    }

    // Add profile menu to updated menus
    const menusWithProfile = addProfileMenu(updatedMenus, user.id);

    const updatedUser = {
      ...user,
      menus: menusWithProfile,
    };

    updateUserState(updatedUser, setUser, currentClubIdRef);

    // Rebuild router with new menus
    await rebuildAppRouter();
    setRoutesReady(true);

    // Show notification
    common.SweetAlert.alert("Permissions updated successfully.", "success");

    // Refresh page after a short delay
    setTimeout(() => {
      refreshPage();
    }, NAVIGATION_DELAY);
  } catch (error) {
    console.error("[AuthContext] Error updating permissions:", error);
    common.SweetAlert.alert(
      "Failed to update permissions. Please refresh the page.",
      "error"
    );
  }
};

